import { Component, OnInit, Input, Output, EventEmitter, HostListener, forwardRef } from '@angular/core';
import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
export const TOGGLE_BUTTON_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ToggleButtonComponent),
  multi: true
};
@Component({
    selector: 'app-toggle-button',
    template: ` <div class="d-flex flex-row justify-content-start align-items-center align-self-center">
                <div class="p-1"><label for="large-rounded-input" style="font-size:0.8rem;">{{labelName}}</label></div>
                <div class="p-1">
                  <div class="button-switch">
                    <input type="checkbox" id="switch-orange" class="switch" [checked]="isDevoteeSuggestion" />
                    <label for="switch-orange" class="{{!!isDevoteeSuggestion ? 'lbl-on' : 'lbl-off'}}">{{!!isDevoteeSuggestion?'On':'Off'}}</label>
                  </div>
                </div>                
              </div> `,
    styleUrls: ['./toggle-button.component.css'],
    providers: [TOGGLE_BUTTON_VALUE_ACCESSOR],
    standalone: false
})
export class ToggleButtonComponent implements OnInit, ControlValueAccessor {

  // template: ` <label for="large-rounded-input" style="font-size:0.8rem;">{{labelName}} {{!!isDevoteeSuggestion?'ON':'OFF'}} </label>
  // <input type='checkbox' class='ios8-switch' id='checkbox-1' [checked]="isDevoteeSuggestion">
  // <label for='checkbox-1'></label>`,

  constructor() { }
  isDevoteeSuggestion: boolean;
  @Input() labelName: any;
  @Input() disabled: boolean;
  @Output() change: EventEmitter<any> = new EventEmitter();
  onChange = (_f: any) => { };
  onTouched = () => { };
  ngOnInit() {
  }
  writeValue(obj: any): void {
    this.isDevoteeSuggestion = !!obj ? true : false;
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouched = fn; }
  // setDisabledState(isDisabled: boolean)?: void {}
  @HostListener('click')
  onClick() {
    if(!this.disabled){
    this.isDevoteeSuggestion = !this.isDevoteeSuggestion;
    this.onChange(this.isDevoteeSuggestion);
    this.change.emit(this.isDevoteeSuggestion);
    }
  }
}
